export const BRAND = {
  name: 'AVOTAS AUTO ZONE',
  addressLine1: '',
  addressLine2: 'No. 106, Udupila, Delgoda',
  telephone: ' 070-2924998, 070-7114433',
  storageKey: 'avoauto',
  localStorageKey: 'avoauto',
  sessionStorageKey: 'avoauto',
};

export const formatAddress = () => `${BRAND.addressLine1}, ${BRAND.addressLine2}`;
